<div class="main-header pl-2 pr-2 lg:pl-4 md:pr-4 bg-primary main-top-header">
  <div class="grid mt-0 justify-content-between align-items-center">
    <div
      class="col-12 md:col-5 lg:col-5 xl:col-8 flex justify-content-center md:justify-content-start align-items-center">
      <img
        (click)="goToMainPage()"
        src="./assets/img/tlogo4.svg"
        class="cursor-pointer"
        alt="logo"
        width="204"
        height="37"
        />
      <span class="h4 text-white border-left-1 border-gray-400 pl-2 ml-2">
        EXAM
      </span>
      <!-- <p-button class="text-white mx-2" *ngIf="(authState$ | async)?.isStaff" (onClick)="toggleMenu()" icon="pi pi-bars" /> -->
    </div>

    <div
      class="flex gap-3 col-12 md:col-3 lg:col-3 xl:col-4 justify-content-end align-items-center pt-2 pb-2"
      >
      <div class="flex gap-2">
        <!-- <div class="relative">
        <p-button icon="pi pi-bell" (onClick)="toggleNotifications()" />
        <div
          *ngIf="showNotifications"
          class="absolute right-0 mt-2 w-100 bg-white shadow-lg rounded z-10"
          >
          <div *ngIf="notifications?.length; else noNotifications">
            <ng-container
              *ngFor="let notification of notifications; let last = last"
              >
              <div class="p-3 text-sm text-gray-900">
                {{ notification }}
              </div>
              <div *ngIf="!last" class="border-t border-gray-200"></div>
            </ng-container>
          </div>
          <ng-template #noNotifications>
            <div class="p-3 text-sm text-gray-500">No notifications</div>
          </ng-template>
        </div>
      </div> -->
      <p-button icon="pi pi-palette" (onClick)="toggleDarkMode()" />
    </div>
    @if (authState$ | async) {
      <div class="flex">
        @if (!(authState$ | async)?.avatar) {
          <p-avatar
            class="flex mr-2"
            icon="pi pi-user"
            shape="circle"
          ></p-avatar>
        }
        @if ((authState$ | async)?.avatar) {
          <p-avatar
            class="flex mr-2"
            [image]="(authState$ | async)?.avatar"
            shape="circle"
          ></p-avatar>
        }
        <div class="md:mr-2 text-white pt-2 pb-2">
          {{ (authState$ | async)?.firstName }}
          {{ (authState$ | async)?.lastName }}
        </div>
      </div>
    }
    <div class="flex">
      <p-button
        (click)="logout()"
        severity="primary"
        size="small"
        icon="pi pi-power-off"
        label="Logout"
        />
    </div>
  </div>
</div>
</div>
